<script>
import { mapGetters, mapActions } from 'vuex';

import RefundModal from '@/components/courses/RefundModal';
import TableView from '@/components/elements/views/TableView';

export default {
    components: {
        RefundModal
    },

    page: {
        title: 'Marathon Orders'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Marathon Orders',
            courseId: '',
            userId: null,
            starsUsed: 0,
            paymentDetails: {},
            paymentMethod: null
        };
    },

    computed: {
        ...mapGetters({
            ALL_COURSE_STATUSES: 'courses/ALL_STATUSES',
            REFUNDABLE_PAYMENT_METHODS: 'courses/REFUNDABLE_PAYMENT_METHODS'
        }),

        options() {
            return {
                addButton: false
            };
        },

        labels() {
            return [
                {
                    value: 'course.number',
                    text: 'Number',
                    width: '130px',
                    type: 'number'
                },
                { value: 'course.name', text: 'Name', width: '200px' },
                {
                    value: 'course.teacher.fullName',
                    sortFieldName: 'teacher.firstName',
                    text: 'Teacher',
                    width: '150px'
                },
                {
                    value: 'course.campuses',
                    text: "Course's campuses",
                    width: '250px',
                    filterFieldName: 'course.campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'user.firstName',
                    text: "User's First Name",
                    width: '250px'
                },
                {
                    value: 'user.lastName',
                    text: "User's Last Name",
                    width: '250px'
                },
                {
                    value: 'email',
                    text: "User's Email",
                    width: '250px'
                },
                {
                    value: 'phone',
                    text: "User's Phone",
                    width: '250px'
                },
                {
                    value: 'user.campuses',
                    text: "User's campuses",
                    width: '250px',
                    filterFieldName: 'user.campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'status',
                    width: '250px',
                    type: 'enum',
                    enumOptions: this.ALL_COURSE_STATUSES
                },
                {
                    text: 'Payment method',
                    value: 'paymentMethod',
                    width: '200px'
                },
                {
                    text: 'Price',
                    value: 'price',
                    width: '200px',
                    type: 'number',
                    filter: 'formatPrice'
                },
                {
                    text: 'Stars used',
                    value: 'starsUsed',
                    type: 'number',
                    width: '200px'
                },
                {
                    value: 'isRefunded',
                    type: 'boolean',
                    isBadge: true,
                    badgeOptions: {
                        trueVariant: 'danger',
                        falseVariant: 'success'
                    },
                    width: '150px'
                },
                {
                    text: 'Refunded amount',
                    value: 'refundedPrice',
                    width: '200px',
                    type: 'number',
                    filter: 'formatPrice'
                },
                {
                    text: 'Registration date',
                    value: 'createdAt',
                    width: '150px',
                    type: 'date',
                    filter: 'formatDate'
                }
            ];
        },

        additionalComponents() {
            return [
                {
                    name: 'refund-modal',
                    props: {
                        courseId: this.courseId,
                        userId: this.userId,
                        paymentDetails: this.paymentDetails || {},
                        starsUsed: this.starsUsed,
                        paymentMethod: this.paymentMethod
                    },
                    events: {
                        success: this.onRefunded
                    }
                }
            ];
        },

        tableActions() {
            return [
                {
                    icon: 'fas fa-money-bill-wave-alt',
                    method: 'refund',
                    where: {
                        isRefunded: {
                            value: false
                        },
                        paymentMethod: {
                            value: this.REFUNDABLE_PAYMENT_METHODS,
                            operator: 'in'
                        },
                        paymentDetailsId: {
                            value: null,
                            operator: 'not'
                        }
                    }
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'courses/getOrders'
        }),

        onRowClick({ courseId }) {
            this.$router.push(`/courses/${courseId}/users`);
        },

        onAddButtonClick() {
            this.$router.push('/courses/add');
        },

        refund(id, index) {
            this.userId = this.items[index].userId;
            this.courseId = this.items[index].courseId;
            this.starsUsed = this.items[index].starsUsed;
            this.paymentMethod = this.items[index].paymentMethod;
            this.paymentDetails = this.items[index].paymentDetails;
            this.$bvModal.show('course-refund');
        },

        onRefunded({ userId, courseId, amount }) {
            const item = this.items.find(
                item => item.userId === userId && item.courseId === courseId
            );

            if (item) {
                item.paymentDetails.isRefunded = true;
                item.isRefunded = true;
                item.refundedPrice = amount;
            }

            this.paymentDetails = {};
        }
    }
};
</script>
